
export const MAX_LENGTH = 255;

export const colors = {
  darkBg: 'rgba(0,0,0, 0.8)',
  primary: '#5571D2',
  primaryDark: '#2F3268',
  primaryMed: '#293290',
  primaryLighter: '#E0E9FF',
  primaryBg: '#BEC3CC',
  primaryTrans: '#E8ECFF',
  secondary: '#FE637C',
  secondaryLighter:'#EAC4CA',
  success: '#34C38F',
  successLight: '#ECF8E3',
  white: '#FFFFFF',
  bgPrimary: '#E0E9FF',
  bgGrey: '#F5F5F5',
  dark: '#333333',
  midiumGrey: '#666666',
  lightGrey : '#F6F6F6',
  darkGrey: '#7D7D7D',
  grey: '#AAAAAA',
  border: 'rgba(245, 245, 245, 1)',
  border2: '#DDDDDD',
  border3: '#D9D9D9',
  pointer1: '#4FD795',  
  pink: '#FFF7F9',
  orangeBg: '#FF961B1A',
  pinkBg: '#FF3B3B1A',
  greyBg: '#E8E8E8',
  blueBg: '#0085FF1A',
  greenBg: '#00BA341A',
  blueGrey: '#8F9BB3',
  workIcon: '#5A6CFA',
  purpleTrans: '#F5F3FE',
  purple: '#7156EE'
};

export const fontSizes = {
  lg: 24,
  md: 20,
  rg: 16,
  sm: 14,  
  xs: 12,
  xxs: 10,
}